import React, { useState } from 'react';
import { FishingMap } from '../components/Map/FishingMap';
import { ThemeToggle } from '../components/Shared/ThemeToggle';
import { Search } from 'lucide-react';
export function MapScreen() {
  const [searchQuery, setSearchQuery] = useState('');
  return <div className="w-full h-full relative" data-id="element-167">
      {/* Mobile theme toggle */}
      <div className="absolute top-4 right-4 z-20 md:hidden" data-id="element-168">
        <div className="float-card p-1" data-id="element-169">
          <ThemeToggle data-id="element-170" />
        </div>
      </div>

      {/* Search */}
      <div className="absolute top-16 md:top-4 left-1/2 -translate-x-1/2 w-full max-w-sm px-4 z-20" data-id="element-171">
        <div className="relative" data-id="element-172">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[var(--text-muted)]" data-id="element-173" />
          <input type="text" placeholder="Search spots..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2.5 rounded-xl float-card border-0 text-sm text-[var(--text-primary)] placeholder-[var(--text-muted)] focus:outline-none focus:ring-2 focus:ring-[var(--accent)] focus:ring-offset-2" data-id="element-174" />
        </div>
      </div>

      <FishingMap searchQuery={searchQuery} data-id="element-175" />
    </div>;
}